import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

/**
 * Summarize channel messages
 */
export const summarizeMessages = async (channelId, options = {}) => {
  const { messageCount = 50, style = 'concise' } = options;
  
  const response = await axios.post(
    `${API_URL}/api/chat/ai/summarize`,
    { channelId, messageCount, style },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Extract tasks from messages
 */
export const extractTasks = async (channelId, messageCount = 50) => {
  const response = await axios.post(
    `${API_URL}/api/chat/ai/extract-tasks`,
    { channelId, messageCount },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Generate smart reply suggestions
 */
export const getSmartReplies = async (channelId, messageId, contextCount = 10) => {
  const response = await axios.post(
    `${API_URL}/api/chat/ai/smart-reply`,
    { channelId, messageId, contextCount },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Analyze sentiment
 */
export const analyzeSentiment = async (channelId, messageCount = 50) => {
  const response = await axios.post(
    `${API_URL}/api/chat/ai/sentiment`,
    { channelId, messageCount },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Generate meeting notes
 */
export const generateMeetingNotes = async (channelId, options = {}) => {
  const { messageCount = 100, title } = options;
  
  const response = await axios.post(
    `${API_URL}/api/chat/ai/meeting-notes`,
    { channelId, messageCount, title },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Categorize message
 */
export const categorizeMessage = async (content) => {
  const response = await axios.post(
    `${API_URL}/api/chat/ai/categorize`,
    { content },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

/**
 * Get productivity insights
 */
export const getProductivityInsights = async (channelId, timeRange = '7d') => {
  const response = await axios.get(
    `${API_URL}/api/chat/ai/insights/${channelId}?timeRange=${timeRange}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};
